import { Locale, LocalizedString } from '@synergy/models';

export const getLocalizedString = (locales: Locale[], value?: LocalizedString): string => {
    if (!value) {
        return '';
    }

    for (const locale of locales) {
        const localized = value[locale];
        if (localized) {
            return localized;
        }
    }

    for (const translation of Object.values(value)) {
        if (translation) {
            return translation;
        }
    }

    return '';
};
